import addError from '../../../utils/error.jsx';

export function request(chatId, content) {
    return {
        type: 'TRADER_CHAT_SEND_MESSAGE_REQUEST',
        chatId,
        content
    };
}

export function error(chatId, errors) {
    addError(errors);

    return {
        type: 'TRADER_CHAT_SEND_MESSAGE_ERROR',
        chatId,
        errors
    };
}

export function finish(chatId) {
    return {
        type: 'TRADER_CHAT_SEND_MESSAGE_FINISH',
        chatId
    };
}
